export const HIGHCHARTS_ALLOWED_TAGS = ['line'];
export const HIGHCHARTS_ALLOWED_ATTRIBUTES = [
  'viewBox',
  'stroke-dasharray',
  'stroke-dashoffset',
  'stroke-linecap',
  'preserveAspectRatio',
  'fit',
  'focusable',
  'xmlns',
];
